import { useState } from "react";
import { FileProcessModel } from "../../../../../hooks/community/models/FileProcessModel";
import { CommentsMessagesModel } from "../../../models/CommentsMessagesModel";
import { CommentsMessageInput } from "../../CommentsMessageInput"
import { CommentsMessagesWrap } from "../../CommentsMessagesWrap"
import { MediaMessageList } from "../../cards/MediaMessageList";
import { MessagesMastermindCircleInfo } from "./cards/MessagesMastermindCircleInfo";
import { showErrorAlert } from "../../../../../helpers/alert";
import { useHistory } from "react-router-dom";

type Props = {
    conversation: any;
    messages: CommentsMessagesModel[];
    onSendMessage: (text: string, files?: File[], replyToId?: number, editingMessageId?: number) => void;
    onReact: (messageId: number, emoji: string) => void;
    onLeave: () => void;
    onLoadMore?: () => void;
    hasMore?: boolean;
    onDelete?: (comment: CommentsMessagesModel) => void;
}

export const MastermindCirclesContent = ({ conversation, messages, onSendMessage, onReact, onLeave, onLoadMore, hasMore, onDelete }: Props) => {
    const [replySelect, setReplySelect] = useState<CommentsMessagesModel | null>(null);
    const [editingMessage, setEditingMessage] = useState<CommentsMessagesModel | null>(null);
    const [files, setFiles] = useState<FileProcessModel[]>([]);
    const history = useHistory();
    const handleSend = async (text: string) => {
        const fileList = files.map(f => f.file);
        await onSendMessage(text, fileList, replySelect ? Number(replySelect.id) : undefined, editingMessage ? Number(editingMessage.id) : undefined);
        setFiles([]);
        setReplySelect(null);
        setEditingMessage(null);
    };

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        const isAtTop = Math.abs(target.scrollTop) + target.clientHeight >= target.scrollHeight - 50;
        if (isAtTop && onLoadMore && hasMore) {
            onLoadMore();
        }
    };

    return (
        <div className="messages-content-wrap">
            <div className="messages-content-comments">
                <div className="w-100">
                    <div className="help-center-sections w-100 tap-flex-center justify-content-start">
                        <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={() => history.goBack()}>
                            Back
                        </div>
                    </div>
                    <div className="d-flex flex-row w-100">
                        <h3>
                            {conversation.title || "Mastermind Circle"}
                        </h3>

                        <div className="d-flex flex-row ms-auto" style={{ gap: '10px' }}>
                            <button className="tool-btn" onClick={() => showErrorAlert({ title: 'coming soon', message: '' })} title="Exit Forum">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10.441 17.0177H5.17435C2.54102 17.0177 1.66602 15.2677 1.66602 13.5094V6.49271C1.66602 3.85937 2.54102 2.98438 5.17435 2.98438H10.441C13.0743 2.98438 13.9493 3.85937 13.9493 6.49271V13.5094C13.9493 16.1427 13.066 17.0177 10.441 17.0177Z" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M16.2659 14.2482L13.9492 12.6232V7.36482L16.2659 5.73982C17.3992 4.94816 18.3326 5.43149 18.3326 6.82316V13.1732C18.3326 14.5648 17.3992 15.0482 16.2659 14.2482Z" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.58398 9.16406C10.2743 9.16406 10.834 8.6044 10.834 7.91406C10.834 7.2237 10.2743 6.66406 9.58398 6.66406C8.89365 6.66406 8.33398 7.2237 8.33398 7.91406C8.33398 8.6044 8.89365 9.16406 9.58398 9.16406Z" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="chat-messages-container" onScroll={handleScroll}>
                    <CommentsMessagesWrap
                        comments={messages}
                        onReact={(c) => onReact(Number(c.id), "👍")}
                        onReply={setReplySelect}
                        onEdit={(c) => setEditingMessage(c)}
                        onDelete={onDelete}
                    />

                </div>
                <CommentsMessageInput 
                    cleanReply={() => setReplySelect(null)}
                    reply={replySelect}
                    onSendComment={handleSend}
                    files={files}
                    OnRemoveFile={(fileToRemove) => setFiles(files.filter(f => f !== fileToRemove))}
                    onAddFile={(f) => setFiles([...files, { file: f, isUploading: false, resourceId: null }] as FileProcessModel[])}
                    editingMessage={editingMessage}
                    onCancelEdit={() => setEditingMessage(null)}
                />
            </div>
            <div className="messages-content-info">
                <MessagesMastermindCircleInfo conversation={conversation} />
                <MediaMessageList
                    mediafiles={messages.flatMap(m => (m.files || []).map(f => ({
                        id: Number(f.id),
                        type: f.resourceType as any,
                        url: f.file,
                        filename: f.title,
                        author: m.author,
                        bytes: f.sizeBytes || f.size || "N/A",
                        createdAt: m.createdAt
                    })))}
                />
            </div>
        </div>
    )
}